import Guest from '@client/Guest'

export default class OrderItem {
	constructor(
		public id: number,
		public unit_amount: number,
		public guest: Guest,
	) {}
}
